// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "parallax" + "." + "ba596af3" + ".chunk.css";
};